// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0tHUy","btn":"Footer_btn__PSK6O","active":"Footer_active__e8xGJ","dark":"Footer_dark__JXDmw","filter":"Footer_filter__sezww"};